import { toast } from "react-toastify";

const DEFAULT_OPTIONS = {
  position: "top-right",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

const buildMessage = (message, description) => {
  if (!description) return message;
  return `${message} ${description}`;
};

const show = (type, message, options = {}) => {
  const { description, ...toastOptions } = options;
  const content = buildMessage(message, description);
  const finalOptions = {
    ...DEFAULT_OPTIONS,
    ...toastOptions,
  };

  switch (type) {
    case "success":
      return toast.success(content, finalOptions);
    case "error":
      return toast.error(content, finalOptions);
    case "warn":
    case "warning":
      return toast.warn(content, finalOptions);
    case "info":
    default:
      return toast.info(content, finalOptions);
  }
};

export const getErrorMessage = (
  error,
  fallback = "Ha ocurrido un error inesperado."
) => {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.data?.message ||
    error?.message ||
    fallback
  );
};

export const notify = {
  show,
  success: (message, options) => show("success", message, options),
  error: (message, options) => show("error", message, options),
  warn: (message, options) => show("warn", message, options),
  warning: (message, options) => show("warning", message, options),
  info: (message, options) => show("info", message, options),
};
